export enum Browser {
  OldIE = 'MSIE ',
  NewIE = 'Trident/'
}
